module.exports = "<iframe [src]=\"url\" class=\"asp-iframe\"></iframe>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/kopija-verifikacije/kopija-verifikacije.component.html
// module id = ./src/app/pages/kopija-verifikacije/kopija-verifikacije.component.html
// module chunks = main